import { render } from "./IconArrowDropUp.vue?vue&type=template&id=7f15a9c2"
import script from "./IconArrowDropUp.vue?vue&type=script&lang=js"
export * from "./IconArrowDropUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__